import { DocumentNode, gql } from '@apollo/client';
import { Avatar, HStack, StackProps, Text, VStack } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { getCompanyJobTitle } from '@/utilities';

import { MemberItem_UserFragment } from './graphql-types/MemberItem_UserFragment';

export const MemberItem: React.FC<
  { member: MemberItem_UserFragment } & StackProps
> & {
  userFragment: DocumentNode;
} = ({ member, ...stackProps }) => {
  return (
    <HStack spacing="2" alignItems="center" {...stackProps}>
      <NextLink href={`/members/${member._id}`}>
        <Avatar
          size="md"
          name={member.displayName}
          src={member?.proxyProfilePictureUrl || undefined}
        />
      </NextLink>
      <VStack textStyle="body" alignItems="start" spacing="0">
        <Text fontWeight="600" color="gray.700">
          {member.displayName}
        </Text>
        <Text color="gray.600">
          {getCompanyJobTitle(member.company, member.jobTitle)}
        </Text>
      </VStack>
    </HStack>
  );
};

MemberItem.userFragment = gql`
  fragment MemberItem_UserFragment on User {
    _id
    displayName
    jobTitle
    company
    proxyProfilePictureUrl(
      input: { w: 140, h: 140, fit: "facearea", facepad: 10.0 }
    )
  }
`;
